<template>
    <div>
        <el-form
            ref="form"
            :inline="true"
            :model="query"
            class="query-form"
            size="mini"
        >
            <el-form-item label="关键词:" class="query-form-item">
                <el-input
                    v-model="query.filter.keyword"
                    placeholder="请输入关键词"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="站点：" class="query-form-item">
                <el-select
                    v-model="query.filter.country_code"
                    ref="carrerSelect"
                    style="width: 120px;"
                    size="mini"
                    filterable
                    clearable
                    @change="change"
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled"
                    >
                        <div class="keywords_arr_div">
                            <icon-svg
                                :icon-class="item.us"
                                style="font-size: 24px;margin-right:5px;"
                            ></icon-svg>
                            <span
                                style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                                >{{ item.title }}</span
                            >
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                    >查询</el-button
                >
                <el-button type="success" @click="showUploadFileList"
                >上传文件列表</el-button
                >
                <el-button type="success" icon="el-icon-plus" @click="add"
                    >导入日搜索量数据</el-button
                >
<!--                <el-button-->
<!--                    type="primary"-->
<!--                    icon="el-icon-download"-->
<!--                    @click="exportData"-->
<!--                    :disabled="disabled"-->
<!--                    >导出日搜索词数据</el-button-->
<!--                >-->
                <el-button
                    type="success"
                    icon="el-icon-download"
                    @click="latelyExportData"
                    :disabled="disabled"
                    >导出最新日搜索词数据</el-button
                >
<!--                <el-button type="success" icon="el-icon-plus" @click="addMonth"-->
<!--                    >导入月搜索量数据</el-button-->
<!--                >-->
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            :height="tableHeight"
            @sort-change="handleSortChange"
            border
            style="width: 100%"
        >
            <el-table-column
                label="关键词"
                sortable="custom"
                prop="keyword"
                min-width="250"
                align="center"
            >
                <template slot-scope="scope">
                    <div
                        style="height: 36px;display: flex;align-items: center;justify-content: center;"
                    >
                        {{ scope.row.keyword }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="国家"
                sortable="custom"
                prop="country_code"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.country_code }}</div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                align="center"
                min-width="100"
                label="日搜索趋势"
            >
                <template slot-scope="scope">
                    <div
                        v-loading="loadingkeyword_tracker"
                        :id="
                            'keyword_tracker' +
                                scope.row.keyword +
                                scope.row.country_code
                        "
                        @click="oncharts_keyword(scope.row)"
                        class="chart spinner_div"
                    ></div>
                </template>
            </el-table-column>
            <el-table-column
                label="最新日搜索量"
                sortable="custom"
                prop="last_show_num"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.last_show_num }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="最新日搜索词展示份额"
                sortable="custom"
                prop="last_show_num"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.keyword_show_share }}</div>
                </template>
            </el-table-column>
<!--			<el-table-column-->
<!--			    :resizable="false"-->
<!--			    align="center"-->
<!--			    min-width="100"-->
<!--			    label="月搜索趋势"-->
<!--			>-->
<!--			    <template slot-scope="scope">-->
<!--			        <div-->
<!--			            v-loading="loadingkeyword_tracker"-->
<!--			            :id="-->
<!--			                'keyword_tracker_month' +-->
<!--			                    scope.row.keyword +-->
<!--			                    scope.row.country_code-->
<!--			            "-->
<!--			            @click="oncharts_keyword_month(scope.row)"-->
<!--			            class="chart spinner_div"-->
<!--			        ></div>-->
<!--			    </template>-->
<!--			</el-table-column>-->
<!--			<el-table-column-->
<!--			    label="最新月搜索量"-->
<!--			    prop="all_show_num_by_month"-->
<!--			    min-width="150"-->
<!--			    align="center"-->
<!--			>-->
<!--			    <template slot-scope="scope">-->
<!--			        <div>{{ scope.row.all_show_num_by_month }}</div>-->
<!--			    </template>-->
<!--			</el-table-column>-->
<!--			<el-table-column-->
<!--			    label="最新月搜索词展示份额"-->
<!--			    prop="last_show_num"-->
<!--			    min-width="150"-->
<!--			    align="center"-->
<!--			>-->
<!--			    <template slot-scope="scope">-->
<!--			        <div>{{ scope.row.keyword_show_share_by_month }}</div>-->
<!--			    </template>-->
<!--			</el-table-column>-->
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[10, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <add
            :visible="ctrl.addDialogVisible"
            :us_arr="us_arr"
            :title="'导入关键词日搜索趋势'"
            @close-callback="closeCllback"
            @error-dialog="errorDialog"
        ></add>

		<addMonth
		    :visible="ctrl.addMonthDialogVisible"
		    :us_arr="us_arr"
		    :title="'导入关键词月搜索趋势'"
		    @close-callback="closeCllback"
		    @error-dialog="errorDialog"
		></addMonth>
        <Upload
            :visible="ctrl.uploadDialogVisible"
            :us_arr="us_arr"
            :title="'导出最近搜索词数据'"
            @close-callback="closeCllback"
        ></Upload>
        <Upload1
            :visible="ctrl.upload1DialogVisible"
            :us_arr="us_arr"
            :title="'导出搜索词数据'"
            @close-callback="closeCllback"
        ></Upload1>
<!--        <charts-keyword-->
<!--            ref="charts_keyword_"-->
<!--            :visible="ctrl.charts_keywordVisible"-->
<!--            :title="ctrl.dialogTitle"-->
<!--            :charts_keyword="charts_keyword"-->
<!--            :charts_id="charts_keyword"-->
<!--            @close-callback="closeCllback"-->
<!--        ></charts-keyword>-->
        <charts-keyword-sb
            ref="charts_keyword_"
            :visible="ctrl.charts_keywordVisible"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_id="charts_keyword"
            @close-callback="closeCllback">
        </charts-keyword-sb>
        <charts-keyword-month
            ref="charts_keyword_month_"
            :visible="ctrl.charts_keywordMonthVisible"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_id="charts_keyword"
            @close-callback="closeCllback"
        ></charts-keyword-month>
        <error-page
            :visible="ctrl.errorVisible"
            :list="listData"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></error-page>
        <upload-file-list :visible="this.uploadFileListVisible" title="上传文件列表" @close-callback="closeCllback"></upload-file-list>
    </div>
</template>

<script>
import * as api from "@/api/Product/Product";
import Add from "./add";
import AddMonth from "./addMonth";
import Upload from "./upload";
import Upload1 from "./upload1";
import * as Highcharts from "highcharts";
import ErrorPage from "@/components/errorPage.vue";
import chartsKeywordSb from "../keyword/charts_keyword_sb";
import ChartsKeywordMonth from "../keyword/charts_keyword_month";
import uploadFileList from './uploadFileList'
export default {
    components: { Add, ErrorPage, chartsKeywordSb, Upload, Upload1, ChartsKeywordMonth, AddMonth ,uploadFileList},
    data() {
        return {
            uploadFileListVisible: false,
            ctrl: {
                addDialogVisible: false,
				addMonthDialogVisible: false,
                charts_keywordVisible: false,
				charts_keywordMonthVisible: false,
                uploadDialogVisible: false,
                upload1DialogVisible: false,
                errorVisible: false
            },
            tableHeight: null,
            formData: {},
            query: {
                page: 1,
                limit: 10,
                order: {},
                filter: {
                    country_code: "",
                    keyword: ""
                }
            },
            us_arr: [
                {
                    us: "US",
                    title: "美国"
                },
                {
                    us: "UK",
                    title: "英国"
                },
                {
                    us: "DE",
                    title: "德国"
                }
            ],
            list: [],
            listData: [],
            requestCount: 0,
            charts_keyword: "",
            country_code_str: "",
            loadingkeyword_tracker: false,
            disabled: false,
            loading: false
        };
    },
    created() {
        this.getList();
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        },
        list: function() {
            this.$nextTick(function() {
                for (let i = 0; i < this.list.length; i++) {
                    if (this.list[i].show_num_sum) {
                        this.workload_tracker(
                            "keyword_tracker" +
                                this.list[i].keyword +
                                this.list[i].country_code,
                            this.list[i]
                        );
						this.workload_tracker_month(
						    "keyword_tracker_month" +
						        this.list[i].keyword +
						        this.list[i].country_code,
						    this.list[i]
						);
                    }
                }
            });
        }
    },
    methods: {
        showUploadFileList(){
            this.uploadFileListVisible = true
        },
        change() {
            this.getList();
        },
        handleSortChange(val) {
            let obj = {};
            if (val.order == "ascending") {
                obj.desc = 0;
                obj.field = val.prop;
            } else if (val.order == "descending") {
                obj.desc = 1;
                obj.field = val.prop;
            }
            this.query.order = obj;
            this.getList();
        },
        exportData() {
            this.ctrl.upload1DialogVisible = true;
        },
        latelyExportData() {
            this.ctrl.uploadDialogVisible = true;
        },
        getList() {
            let count = this.requestCount;
            count = count + 1;
            this.requestCount = count;
            this.loading = true;
            this.loadingkeyword_tracker = true;
            api.sb_page_list(this.query)
                .then(res => {
                    this.loading = false;
                    if (this.requestCount != count) {
                        this.loadingWorkload = false;
                        this.loadingkeyword_tracker = false;
                        return;
                    }
                    if (res.code === 0) {
                        this.list = res.data.list;
                        this.query.page = res.data.page;
                        this.query.total = res.data.total;
                        let arr_key_obj = {};
                        let that = this;
                        let list = JSON.parse(JSON.stringify(that.list));
                        for (let i = 0; i < list.length; i++) {
                            if (
                                arr_key_obj[list[i].country_code] == undefined
                            ) {
                                arr_key_obj[list[i].country_code] = [];
                            }
                            arr_key_obj[list[i].country_code].push(
                                list[i].keyword
                            );
                        }
                        if (JSON.stringify(arr_key_obj) != "{}") {
                            for (let key in arr_key_obj) {
                                this.trend_batch(arr_key_obj[key], key, count);
                                // this.trend_batch_by_month(arr_key_obj[key], key, count);
                            }
                        } else {
                            this.loadingkeyword_tracker = false;
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //获取关键词曲线图数据
        async trend_batch(arr, country_code, count) {
            let that = this;
            if (that.requestCount != count) {
                return (that.loadingkeyword_tracker = false);
            }
            await api.sb_search_trend({
                    keywords: arr,
                    country_code: country_code
                })
                .then(res => {
                    that.loadingkeyword_tracker = false;
                    if (that.requestCount != count) return;
                    let list = JSON.parse(JSON.stringify(that.list));
                    if (res.code === 0) {
                        let data = res.data;
                        for (let i = 0; i < list.length; i++) {
                            if (list[i].country_code == country_code) {
                                list[i].show_num_sum_date =
                                    data[list[i].keyword].date;
                                list[i].show_num_sum =
                                    data[list[i].keyword].show_num_sum;
                                list[i].keyword_show_share_num =
                                    data[list[i].keyword].keyword_show_share_num;
                            }
                        }
                        that.list = list;
                    } else {
                        that.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    that.loadingkeyword_tracker = false;
                });
        },
		//获取关键词曲线图数据-月
		async trend_batch_by_month(arr, country_code, count) {
		    let that = this;
		    if (that.requestCount != count) {
		        return (that.loadingkeyword_tracker = false);
		    }
		    await api.search_trend_batch_by_month({
		            keywords: arr,
		            country_code: country_code
		        })
		        .then(res => {
		            that.loadingkeyword_tracker = false;
		            if (that.requestCount != count) return;
		            let list = JSON.parse(JSON.stringify(that.list));
		            if (res.code === 0) {
		                let data = res.data;
		                for (let i = 0; i < list.length; i++) {
		                    if (list[i].country_code == country_code) {
		                        list[i].show_num_sum_date_month =
		                            data[list[i].keyword].date;
		                        list[i].show_num_sum_month =
		                            data[list[i].keyword].show_num_sum;
		                        list[i].keyword_show_share_num_month =
		                            data[list[i].keyword].keyword_show_share_num;
		                    }
		                }
		                that.list = list;
		            } else {
		                that.$message({
		                    type: "error",
		                    message: res.message
		                });
		            }
		        })
		        .catch(() => {
		            that.loadingkeyword_tracker = false;
		        });
		},
        workload_tracker(id_name, data) {
            let workload_id = document.getElementById(id_name);
            let datas = [];
            for (let i = 0; i < data.show_num_sum.length; i++) {
                datas.push(
                    data.show_num_sum[i] == null
                        ? null
                        : data.show_num_sum[i] * -1
                );
            }
            this.sparkLine(workload_id, datas, data.show_num_sum_date, 2);
        },
		workload_tracker_month(id_name, data) {
		    let workload_id = document.getElementById(id_name);
		    let datas = [];
		    for (let i = 0; i < data.show_num_sum_month.length; i++) {
		        datas.push(
		            data.show_num_sum_month[i] == null
		                ? null
		                : data.show_num_sum_month[i] * -1
		        );
		    }
		    this.sparkLine(workload_id, datas, data.show_num_sum_date_month, 2);
		},
        sparkLine(div, datas, dates, index) {
            var options = {
                chart: {
                    borderWidth: 0,
                    type: "area",
                    margin: [8, 40, 8, 10],
                    width: 100,
                    height: 36,
                    style: {
                        overflow: "visible"
                    },
                    skipClone: true
                },
                title: {
                    text: null
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    categories: dates,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: [],
                    tickWidth: 0,
                    lineColor: "#fff"
                },
                yAxis: {
                    reversed: index == 1 ? false : true,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    minPadding: 0,
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: []
                },
                legend: {
                    enabled: false
                },
                exporting: { enabled: false },
                tooltip: {
                    formatter: function() {
                        if (index == 1) {
                            return `<span style="font-size: 10px;">${
                                this.x
                            }</span><br/><b>${306 - this.y}</b>`;
                        }
                        if (index == 2) {
                            return `<span style="font-size: 10px;">${
                                this.x
                            }</span><br/><b>${this.y * -1}</b>`;
                        }
                    },
                    hideDelay: 0,
                    outside: true
                },
                series: [{ data: datas }],
                plotOptions: {
                    series: {
                        animation: false,
                        lineWidth: 1,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        marker: {
                            radius: 1,
                            states: {
                                hover: {
                                    radius: 2
                                }
                            }
                        },
                        fillOpacity: 0.25
                    },
                    column: {
                        negativeColor: "#910000",
                        borderColor: "silver"
                    }
                }
            };
            return new Highcharts.Chart(div, options);
        },
        //打开关键词曲线图
        oncharts_keyword(data) {
            let that = this;
            this.charts_keyword = data.keyword;
            this.ctrl.dialogTitle = `${data.keyword} 的日搜索趋势图`;
            this.ctrl.charts_keywordVisible = true;
            setTimeout(function() {
                that.$refs.charts_keyword_.getList(
                    data.keyword,
                    null,
                    data.country_code
                );
            }, 100);
        },//打开关键词曲线图
        oncharts_keyword_month(data) {
            let that = this;
            this.charts_keyword = data.keyword;
            this.ctrl.dialogTitle = `${data.keyword} 的月搜索趋势图`;
			this.ctrl.charts_keywordMonthVisible = true;
            setTimeout(function() {
                that.$refs.charts_keyword_month_.getList(
                    data.keyword,
                    null,
                    data.country_code
                );
            }, 100);
        },
        //错误内容
        errorPageDialog() {
            this.ctrl.errorVisible = true;
        },
        //错误页面
        errorDialog(data) {
            let that = this;
            this.listData = data.data;
            setTimeout(function() {
                that.errorPageDialog();
            }, 10);
        },
        //添加文件夹
        add() {
            this.ctrl.addDialogVisible = true;
        },
        //添加文件夹
        addMonth() {
            this.ctrl.addMonthDialogVisible = true;
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        //重置
        onReset() {
            this.query.filter.country_code = "";
            this.query.filter.keyword = "";
            this.query.page = 1;
            this.query.limit = 20;
            this.getList();
        },
        //查询
        onSubmit() {
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.uploadFileListVisible = false;
            this.ctrl.addDialogVisible = false;
			this.ctrl.addMonthDialogVisible = false;
            this.ctrl.errorVisible = false;
            this.ctrl.uploadDialogVisible = false;
            this.ctrl.charts_keywordVisible = false;
            this.ctrl.charts_keywordMonthVisible = false;
            this.ctrl.upload1DialogVisible = false;
            if (isshow) return;
            this.getList();
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #fff !important;
}
/deep/ .el-button--mini {
    padding: 5px 5px !important;
}
.pen:hover {
    cursor: pointer;
    text-decoration: underline;
}
</style>
